import {
  INTEGRATION_TYPES,
  type IntegrationDefinition,
  type IntegrationEndpointInfo,
} from '../types'

export const DEFAULT_CITYWORKS_CONFIG = {}

const CITYWORKS_ENDPOINTS: IntegrationEndpointInfo[] = [
  {
    name: 'Create Service Request',
    method: 'POST',
    description: 'Create a new Cityworks service request',
    toolName: 'create_service_request',
  },
  {
    name: 'Update Service Request',
    method: 'POST',
    description: 'Update an existing Cityworks service request',
    toolName: 'update_service_request',
  },
  {
    name: 'Get Service Request',
    method: 'POST',
    description: 'Retrieve a Cityworks service request by ID',
    toolName: 'get_service_request',
  },
  {
    name: 'Add Comments',
    method: 'POST',
    description: 'Add comments to a Cityworks service request',
    toolName: 'add_comments',
  },
]

export const cityworksIntegration: IntegrationDefinition = {
  id: INTEGRATION_TYPES.CITYWORKS,
  title: 'Cityworks',
  defaultConnectionName: 'Cityworks',
  logo: 'https://polimorphic-static.s3.us-east-2.amazonaws.com/3p-logos/cityworks-logo.png',
  icon: 'https://polimorphic-static.s3.us-east-2.amazonaws.com/3p-logos/cityworks-icon.png',
  cardDescription:
    'Connect to Cityworks AMS to manage service requests, work orders, and infrastructure assets.',
  modalDescription:
    'Connect to Cityworks AMS to create and manage service requests. The integration will automatically configure all available API endpoints.',
  formFields: [
    {
      name: 'host',
      label: 'Base URL',
      placeholder: 'e.g., cityworks.example.org/CityworksProd',
      helperText: 'The Cityworks server URL for your organization (without https://)',
      required: true,
      type: 'text',
    },
    {
      name: 'username',
      label: 'Username',
      placeholder: 'Enter your Cityworks username',
      helperText: 'Your Cityworks login username',
      required: true,
      type: 'text',
    },
    {
      name: 'password',
      label: 'Password',
      placeholder: 'Enter your Cityworks password',
      helperText: 'Your password is stored securely and encrypted',
      required: true,
      type: 'password',
    },
  ],
  apiConfig: {
    createEndpoint: '/integrations/generate-cityworks-integration/',
    buildPayload: (formData, config, organizationId, organizationIdentityId) => {
      const host = formData.host.replace(/^https?:\/\//, '').replace(/\/+$/, '')
      return {
        organization_identity_id: organizationIdentityId,
        username: formData.username,
        password: formData.password,
        base_url: `https://${host}`,
        connection_name: formData.connectionName || 'Cityworks',
        excluded_endpoints: (config.excluded_endpoints as string[]) || [],
      }
    },
    authTokenName: 'password',
    buildTestCredentials: (formData) => {
      const host = formData.host.replace(/^https?:\/\//, '').replace(/\/+$/, '')
      return {
        base_url: `https://${host}`,
        username: formData.username,
        password: formData.password,
      }
    },
  },
  defaultConfig: { ...DEFAULT_CITYWORKS_CONFIG },
  endpoints: CITYWORKS_ENDPOINTS,
  hostValidation: {
    pattern: /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/[a-zA-Z0-9._-]+)*$/,
    example: 'cityworks.example.org/CityworksProd',
  },
}
